import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';

Vue.use(VueRouter);

import loyaltyPanelRoutes from './loyaltyPanel';
import storePanelRoutes from './storepanel';
import supplierPanelRoutes from './supplierPanel';

const routes = [
  {
    path: '/',
    name: 'Root',
    components: {
      header: () => import(/* webpackChunkName: "header" */ '@/components/Header.vue'),
      default: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue'),
    },
  },
  {
    path: '/:lang',
    name: 'Home',
    components: {
      header: () => import(/* webpackChunkName: "header" */ '@/components/Header.vue'),
      default: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue'),
      footer: () => import(/* webpackChunkName: "footer" */ '@/components/Footer.vue'),
    },
  },
  {
    path: '/:lang/points-pos',
    name: 'PointsPos',
    components: {
      header: () => import(/* webpackChunkName: "posHeader" */ '@/components/PosHeader.vue'),
      default: () => import(/* webpackChunkName: "pointsPos" */ '@/views/PointsPos.vue'),
      footer: () => import(/* webpackChunkName: "footer" */ '@/components/Footer.vue'),
    },
  },
  {
    path: '/:lang/loyaltyPanel',
    name: 'LoyaltyPanel',
    meta: {
      requiresAuth: true,
    },
    components: {
      header: () =>
        import(/* webpackChunkName: "loyaltyHeader" */ '@/components/LoyaltyHeader.vue'),
      default: () =>
        import(/* webpackChunkName: "loyaltyPanel" */ '@/views/loyaltyPanel/LoyaltyPanel.vue'),
    },
    children: loyaltyPanelRoutes,
  },
  {
    path: '/:lang/storePanel',
    name: 'StorePanel',
    meta: {
      requiresAuth: true,
    },
    components: {
      header: () => import(/* webpackChunkName: "storeHeader" */ '@/components/StoreHeader.vue'),
      default: () =>
        import(/* webpackChunkName: "storePanel" */ '@/views/storePanel/StorePanel.vue'),
    },
    children: storePanelRoutes,
  },
  {
    path: '/:lang/supplierPanel',
    name: 'SupplierPanel',
    meta: {
      requiresAuth: true,
    },
    components: {
      header: () =>
        import(/* webpackChunkName: "loyaltyHeader" */ '@/components/SupplierHeader.vue'),
      default: () =>
        import(/* webpackChunkName: "loyaltyPanel" */ '@/views/supplierPanel/SupplierPanel.vue'),
    },
    children: supplierPanelRoutes,
  },
  {
    path: '/:lang/app-providers',
    name: 'AppProviders',
    components: {
      header: () =>
        import(/* webpackChunkName: "appProvidersHeader" */ '@/components/AppProvidersHeader.vue'),
      default: () => import(/* webpackChunkName: "appProviders" */ '@/views/AppProviders.vue'),
    },
  },
  {
    path: '/:lang/subscription-plans',
    name: 'SubscriptionPlans',
    components: {
      header: () =>
        import(/* webpackChunkName: "appProvidersHeader" */ '@/components/AppProvidersHeader.vue'),
      default: () => import(/* webpackChunkName: "appProviders" */ '@/views/SubscriptionPlans.vue'),
    },
  },
  {
    path: '/:lang/create-account',
    name: 'CreateAccount',
    components: {
      default: () => import(/* webpackChunkName: "appProviders" */ '@/views/Register.vue'),
    },
  },
  {
    path: '/:lang/create-company',
    name: 'CreateCompany',
    components: {
      default: () =>
        import(
          /* webpackChunkName: "appProviders" */ '@/components/register/createCompanyStore/CreateCompany.vue'
        ),
    },
  },
  {
    path: '/:lang/create-store',
    name: 'CreateStore',
    components: {
      default: () =>
        import(
          /* webpackChunkName: "appProviders" */ '@/components/register/createCompanyStore/CreateStore.vue'
        ),
    },
  },
  {
    path: '/:lang/sign-in',
    name: 'SignIn',
    component: () => import(/* webpackChunkName: "signIn" */ '@/views/SignIn.vue'),
  },
  {
    path: '/:lang/password-recovery',
    name: 'PasswordRecovery',
    component: () =>
      import(/* webpackChunkName: "passwordRecovery" */ '@/views/PasswordRecovery.vue'),
  },
  {
    path: '/:lang/user-stores',
    meta: {
      requiresAuth: true,
    },
    name: 'UserStores',
    component: () => import(/* webpackChunkName: "userStores" */ '@/views/UserStores.vue'),
  },
  {
    path: '*',
    name: 'NotFound',
    component: () => import(/* webpackChunkName: "notFound" */ '@/views/NotFound.vue'),
  },
  {
    path: '/en/loyaltyPanel/payment/success',
    name: 'SuccessMessage',
    component: () =>
      import(
        /* webpackChunkName: "SuccessMessage" */ '@/views/stripePaymentMessages/successMessage.vue'
      ),
  },
  {
    path: '/en/loyaltyPanel/payment/error',
    name: 'ErrorMessage',
    component: () =>
      import(
        /* webpackChunkName: "ErrorMessage" */ '@/views/stripePaymentMessages/errorMessage.vue'
      ),
  },
  {
    path: '/:lang/terms-of-service',
    name: 'TermsOfService',
    component: () => import(/* webpackChunkName: "ErrorMessage" */ '@/views/TermsOfService.vue'),
  },
  {
    path: '/:lang/privacy-policy',
    name: 'PrivacyPolicy',
    component: () => import(/* webpackChunkName: "ErrorMessage" */ '@/views/PrivacyPolicy.vue'),
  },
  {
    path: '/:lang/direct-marketing',
    name: 'DirectMarketing',
    component: () => import(/* webpackChunkName: "ErrorMessage" */ '@/views/DirectMarketing.vue'),
  },
  {
    path: '/fb/coupons/:couponId',
    name: 'FbCoupon',
    components: {
      default: () =>
        import(/* webpackChunkName: "home" */ '@/views/storePanel/coupons/CouponDetails.vue'),
    },
  },

  {
    path: '/:lang/forbidden',
    name: 'Forbidden',
    component: () => import(/* webpackChunkName: "Forbidden" */ '@/views/Forbidden.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

store.dispatch('getPermission');
import { isEmpty } from 'lodash';

let getPermission = async (path) => {
  if (path && !isEmpty(store.state.permissions) && !isEmpty(store.state.storePermissions)) {
    return store.getters.getPermission(path);
  }
  return true;
};

let checkAuthPermission = (to, next) => {
  if (
    to.matched.some((record) => record.meta.requiresAuth) &&
    !localStorage.getItem('accessToken')
  ) {
    next({
      name: 'SignIn',
      params: {
        lang: to.params.lang || 'en',
      },
      replace: true,
    });
  } else if (to.meta?.permissionPath && !getPermission(to.meta?.permissionPath)) {
    next({
      name: 'Forbidden',
      params: {
        lang: to.params.lang || 'en',
      },
      replace: true,
    });
  } else {
    next();
  }
};

router.beforeEach((to, from, next) => {
  if (!to?.name) {
    next({
      name: 'NotFound',
      params: { lang: to.params.lang || 'en' },
      replace: true,
    });
    return;
  }
  if (to.name === 'Root' || to.name === 'Home') {
    const lang = to.params.lang || 'en';
    if (localStorage.getItem('accessToken')) {
      next({
        name: 'UserStores',
        params: { lang },
        replace: true,
      });
      return;
    } else {
      next({
        name: 'SignIn',
        params: { lang },
        replace: true,
      });
      return;
    }
  }
  checkAuthPermission(to, next);
});
router.afterEach((to, from, next) => {
  if (next) {
    checkAuthPermission(to, next);
  }
});

export default router;
